export interface ClickLikeEvent {
  button: number;
  ctrlKey?: boolean;
  metaKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
  preventDefault: () => void;
}

export const interceptLeftClick =
  (onLeftClick: () => void) =>
  (e: ClickLikeEvent) => {
    const isLeftClick = e.button === 0;
    const isModified = !!(e.ctrlKey || e.metaKey || e.shiftKey || e.altKey);

    if (isLeftClick && !isModified) {
      e.preventDefault();
      onLeftClick();
    }
  };
